import * as React from "react";
import Translate from '../../common/functions/translate';
import { Link } from "react-router-dom";
import AuthService from "../../services/authService";
import { DashboardModel } from "../../models/dashboardModel";
import Spinner from '../../common/components/spinner/spinner';
import DashboardService from "../../services/dashboardService";

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  validationMessage: string;
  dashboard: DashboardModel
}

class HomePageComponent extends React.Component<IProps, IState> {
  authService = new AuthService();
  dashboardService = new DashboardService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      isLoading: false,
      dashboard: new DashboardModel(),
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.dashboardService.getData().then(
      (data: any) => {
        this.setState({
          isLoading: false,
          dashboard: data
        });
      },
      error => {
        this.setState({
          isLoading: false
        })
      }
    )
  }

  render() {
    const { dashboard, isLoading } = this.state;

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {/* <h3>{Translate('Dashboard')}</h3> */}
        <div className="p-grid p-fluid dashboard">
          {this.authService.checkIsAdmin()
            ? <div className="p-col-12 p-lg-3">
              <Link to="/users">
                <div className="card summary">
                  <span className="title">{Translate("Users")}</span>
                  <span className="detail">
                    {Translate("NumberOfActiveUsers")}
                  </span>
                  <span className="count users">{dashboard.activeUsersCount ? dashboard.activeUsersCount : 0}</span>
                </div>
              </Link>
            </div>
            : null}

          {this.authService.checkIsProductManager() || this.authService.checkIsAdmin()
            ? <div className="p-col-12 p-lg-3">
              <Link to="/products">
                <div className="card summary">
                  <span className="title">{Translate("Articles")}</span>
                  <span className="detail">{Translate("NumberOfActiveArticles")}</span>
                  <span className="count products">{dashboard.activeProductsCount ? dashboard.activeProductsCount : 0}</span>
                </div>
              </Link>
            </div>
            : null}

          {this.authService.checkIsTrader() || this.authService.checkIsRegionalManager() || this.authService.checkIsAdmin()
            ? <div className="p-col-12 p-lg-3">
              <Link to="/offers">
                <div className="card summary">
                  <span className="title">{Translate("Offers")}</span>
                  <span className="detail">{Translate("NumberOfActiveOffers")}</span>
                  <span className="count offers">{dashboard.activeOffersCount ? dashboard.activeOffersCount : 0} </span>
                </div>
              </Link>
            </div>
            : null}

          {this.authService.checkIsAdmin()
            ? <div className="p-col-12 p-lg-3">
              <Link to="/configuration/regions">
                <div className="card summary">
                  <span className="title">{Translate("Regions")}</span>
                  <span className="detail">{Translate("NumberOfActiveRegions")}</span>
                  <span className="count regions">{dashboard.activeRegionsCount ? dashboard.activeRegionsCount : 0}</span>
                </div>
              </Link>
            </div>
            : null}

          {this.authService.checkIsAdmin()
            ? <div className="p-col-12 p-lg-3">
              <Link to="/configuration/categories">
                <div className="card summary">
                  <span className="title">{Translate("Categories")}</span>
                  <span className="detail">{Translate("NumberOfActiveCategories")}</span>
                  <span className="count categories">{dashboard.activeCategoriesCount ? dashboard.activeCategoriesCount : 0}</span>
                </div>
              </Link>
            </div>
            : null}

        </div>
      </div >
    )
  }
}

export default HomePageComponent;